export default "__VITE_ASSET__D_Qnn44j__"